import {gql} from '@apollo/client/core';

export const HeadDataFragment = gql`
  fragment headData on Head {
    id
    path
    title
    meta {
      charset
      content
      httpEquiv
      meta_id
      itemprop
      name
      property
      scheme
      url
    }
    link {
      charset
      crossorigin
      href
      hreflang
      media
      rel
      rev
      sizes
      target
      type
    }
    structuredDataScheme
  }
`;
